<template>
  <div class="add_pricing_modal">
    <widgetModal
      :title="form.id ? 'Update location' : 'Add New Location'"
      subtitle="Location information"
      btnlefttext="Cancel"
      btnrighttext="Save"
      :leftloading="false"
      :rightloading="submit_location_loading"
      :footerhidden="false"
      @onLeftClick="onComfirm"
      @onRightClick="onClose"
    >
      <div class="widget-modal-body-noscoll">
        <b-field label="Select Location">
          <widgetSelect
            v-model="form.location"
            :opt="countries"
            placeholder="Select location"
          ></widgetSelect>
        </b-field>

        <b-field label="Visibility Status" expanded>
          <b-select v-model="form.status" expanded>
            <option value="pending">Pending</option>
            <option value="published">Published</option>
          </b-select>
        </b-field>
      </div>
    </widgetModal>
  </div>
</template>

<script>
export default {
  name: "add_pricing_modal",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      submit_location_loading: false,
      form: {
        id: null,
        location: "default",
        location_name: "",
        status: "pending",
      },
    };
  },
  computed: {
    countries() {
      let vm = this;
      return vm.$store.state.Finance.countries;
    },
  },
  mounted() {
    let vm = this;
    if (vm.content) {
      vm.setFormFields();
    } else {
      vm.resetFormFields();
    }
  },
  methods: {
    resetFormFields() {
      let vm = this;
      vm.form = {
        id: null,
        location: "default",
        location_name: "",
        status: "pending",
      };
    },
    setFormFields() {
      let vm = this;
      vm.form = {
        id: vm.content.id,
        location: vm.content.location,
        location_name: vm.content.location_name,
        status: vm.content.status,
      };
    },
    onComfirm() {
      let vm = this;
      // Start validate
      const rules = {
        location: {
          run: (value) => {
            if (!value) {
              return "Please select location";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submit_location_loading = true;
        let countryItem = vm.countries.find(
          (item) => item.value == vm.form.location
        );
        vm.form.location_name = countryItem.label;
        if (!vm.form.id) {
          vm.$store
            .dispatch("STREAMING_ADD_STREAM_LOCATION", vm.form)
            .then((response) => {
              vm.submit_location_loading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.$emit("success");
            })
            .catch(({ response }) => {
              vm.submit_location_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        } else {
          vm.$store
            .dispatch("STREAMING_UPDATE_STREAM_LOCATION", vm.form)
            .then((response) => {
              vm.submit_location_loading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.$emit("success");
            })
            .catch(({ response }) => {
              vm.submit_location_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        }
      }
    },
    onClose() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.add_pricing_modal {
  .modal-tabs {
    padding: 10px 15px;
  }
}
</style>

